<template>
  <transition name="msgbox-fade">
    <div
      class="el-message-box__wrapper popup"
      tabindex="-1"
      v-show="visible"
      @click.self="handleWrapperClick"
      role="dialog"
      aria-modal="true"
      :aria-label="title || 'dialog'">
      <div class="el-message-box" :class="[center && 'el-message-box--center']" :style="{width: width}">
        <div class="el-message-box__header" v-if="title !== null" :style="{background: background}">
          <div class="el-message-box__title">
            <div
              :class="['el-message-box__status', icon]"
              v-if="icon && center">
            </div>
            <span>{{ title }}</span>
          </div>
          <button
            type="button"
            class="el-message-box__headerbtn"
            aria-label="Close"
            v-if="showClose"
            @click="handleAction(distinguishCancelAndClose ? 'close' : 'cancel')"
            @keydown.enter="handleAction(distinguishCancelAndClose ? 'close' : 'cancel')">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <component ref="component" :is="component" :parameter="parameter"></component>
        </div>
        <div class="el-message-box__btns" style="text-align: center">
          <el-button
            :loading="cancelButtonLoading"
            :round="roundButton"
            size="small"
            @click.native="handleAction('cancel')"
            @keydown.enter="handleAction('cancel')">
            {{ cancelButtonText || t('el.messagebox.cancel') }}
          </el-button>
          <el-button
            class="el-button--primary"
            :loading="confirmButtonLoading"
            ref="confirm"
            :round="roundButton"
            size="small"
            @click.native="handleAction('confirm')"
            @keydown.enter="handleAction('confirm')">
            {{ confirmButtonText || t('el.messagebox.confirm') }}
          </el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import Popup from 'element-ui/lib/utils/popup'
import Locale from 'element-ui/lib/mixins/locale'
import ElButton from 'element-ui/packages/button'
import Dialog from 'element-ui/lib/utils/aria-dialog'
import Calculation from '../calculation/calculation'

let popup

export default {
  mixins: [Popup, Locale],
  props: {
    modal: {
      default: true
    },
    lockScroll: {
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      default: true
    },
    closeOnPressEscape: {
      default: true
    },
    closeOnHashChange: {
      default: true
    },
    center: {
      default: false,
      type: Boolean
    },
    roundButton: {
      default: false,
      type: Boolean
    }
  },
  components: {
    Calculation,
    ElButton
  },

  computed: {
    icon () {
      const iconClass = this
      return iconClass
    }
  },
  methods: {
    getSafeClose () {
      const currentId = this.uid
      return () => {
        this.$nextTick(() => {
          if (currentId === this.uid) this.doClose()
        })
      }
    },
    doClose () {
      let _this = this
      if (this.action === 'confirm') {
        this.$refs.component.validate().then(() => {
          _this.value = _this.$refs.component === undefined ? _this.value : _this.$refs.component.getValue()
          _this.closePanel()
        }).catch(error => {
          this.$message.error(error.message)
        })
      } else {
        this.closePanel()
      }
    },
    closePanel () {
      if (!this.visible) return
      this.visible = false

      this.onClose && this.onClose()
      popup.closeDialog() // 解绑
      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200)
      }
      this.opened = false
      this.doAfterClose()
      let _this = this
      setTimeout(() => {
        if (_this.action) _this.callback(_this.action, _this.value)
        _this.component = ''
      })
    },

    handleWrapperClick () {
      if (this.closeOnClickModal) {
        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel')
      }
    },
    handleAction (action) {
      this.action = action
      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose()
        this.beforeClose(action, this, this.close)
      } else {
        this.doClose()
      }
    },
    getFirstFocus () {
      const btn = this.$el.querySelector('.el-message-box__btns .el-button')
      const title = this.$el.querySelector('.el-message-box__btns .el-message-box__title')
      return btn || title
    },
    getInputElement () {
      const inputRefs = this.$refs.input.$refs
      return inputRefs.input || inputRefs.textarea
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.uid++
        this.focusAfterClosed = document.activeElement
        popup = new Dialog(this.$el, this.focusAfterClosed, this.getFirstFocus())
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (this.closeOnHashChange) {
        window.addEventListener('hashchange', this.close)
      }
    })
  },
  beforeDestroy () {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close)
    }
    setTimeout(() => {
      popup.closeDialog()
    })
  },
  data () {
    return {
      uid: 1,
      title: undefined,
      type: '',
      width: '',
      iconClass: '',
      action: '',
      confirmButtonText: '',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonDisabled: false,
      callback: null,
      focusAfterClosed: null,
      distinguishCancelAndClose: false,
      component: '',
      componentOption: '',
      background: '#edeeee',
      parameter: {},
      value: ''
    }
  }
}
</script>

<style lang="scss">
  .popup {
    .el-message-box__title {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/popup/popup.vue